/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);

__webpack_require__(3);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(4);

var _keys2 = _interopRequireDefault(_keys);

var _stormbox = __webpack_require__(16);

var _stormbox2 = _interopRequireDefault(_stormbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyAutocomplete(id) {
    var hiddenElement = _stormbox2.default.byId(id);
    var anchor = _stormbox2.default.byId('anchor_' + id);
    var data = $(anchor).data();
    var references = (0, _keys2.default)(data).filter(function (item) {
        return item.substr(0, 21) === 'autocompleteReference';
    }).map(function (item) {
        var paramName = item.substr(21).toLowerCase();
        var elemName = data[item];
        return [paramName, _stormbox2.default.byId(elemName)];
    }).reduce(function (acc, reference) {
        acc[reference[0]] = reference[1];
        return acc;
    }, {});

    var otherParams = (0, _keys2.default)(data).filter(function (item) {
        return item.substr(0, 23) === 'autocompleteOtherParams';
    }).map(function (item) {
        var paramName = item.substr(23).toLowerCase();
        var elemName = data[item];
        return [paramName, elemName];
    }).reduce(function (acc, reference) {
        acc[reference[0]] = reference[1];
        return acc;
    }, {});

    var textElement = $('[data-autocomplete-text="' + data.autocomplete + '"]').get(0);

    return new _stormbox2.default({
        hiddenInput: data.autocompleteList ? _stormbox2.default.byArrayName(id) : hiddenElement,
        textInput: data.autocompleteList ? _stormbox2.default.byArrayName('text_' + id) : textElement,
        hiddenInputName: id,
        textInputName: 'text_' + id,
        multiple: data.autocompleteList,
        anchorElement: data.autocompleteList ? anchor : undefined,
        distinct: data.autocompleteDistinct,
        debounceTime: data.autocompleteDebouncetime,
        queryParam: data.autocompleteQueryparam,
        autoSelectWhenOneResult: data.autocompleteSelectfirst,
        clearOnType: data.autocompleteClearontype,
        autoFind: data.autocompleteAutofind,
        customText: data.autocompleteRecordtext,
        emptyItem: data.autocompleteEmptyitem,
        minLength: data.autocompleteMinlength,
        source: new _stormbox2.default.AjaxSource(data.autocompleteUrl),
        references: references,
        otherParams: otherParams,
        softErrors: true,
        messages: {
            emptyItemName: 'Nenhum',
            searchPlaceholder: 'Digite para buscar...',
            singularMultipleItems: 'item',
            pluralMultipleItems: 'itens',
            noData: 'Sem itens'
        }
    });
}

window.applyAutocomplete = applyAutocomplete;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _diacritics = __webpack_require__(15);

$(document).ready(function () {
    // MetsiMenu
//    $('#side-menu').metisMenu();

    // Menu search
    $('.menu-search').keyup(function (event) {
        if (event.target.value.length) {
            var regExp = new RegExp((0, _diacritics.remove)(event.target.value).toLowerCase().replace(/[^a-z0-9\s]/g, '.*').replace(/\s+/, '\\s'));
            $('#side-menu a[href!="#"]').each(function (index, item) {
                var text = (0, _diacritics.remove)(item.innerText).toLowerCase();
                if (text.match(regExp)) {
                    item.classList.add('menu-search-show-item');
                    item.classList.remove('menu-search-hide-item');
                } else {
                    item.classList.add('menu-search-hide-item');
                    item.classList.remove('menu-search-show-item');
                }
            });
            $('#side-menu ul').each(function (index, item) {
                item.parentElement.classList.add('menu-search-hide-item');
                item.parentElement.classList.remove('menu-search-show-item');

                if ($(item).find('.menu-search-show-item').length) {
                    item.parentElement.classList.add('menu-search-show-item');
                    item.parentElement.classList.remove('menu-search-hide-item');
                }
            });
            $('.collapse').addClass('in').css('height', null);
        } else {
            $('li:not(.active) .collapse').removeClass('in');
            $('.menu-search-hide-item, .menu-search-show-item').removeClass('menu-search-hide-item').removeClass('menu-search-show-item');
        }
    });
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(5), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(14);
module.exports = __webpack_require__(0).Object.keys;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(6);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(11)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(7)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(param){
        return this instanceof C ? new C(param) : C(param);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
  }
};
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(10);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(8);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(13);

__webpack_require__(12)('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

exports.remove = removeDiacritics;

var replacementList = [
  {
    base: ' ',
    chars: "\u00A0",
  }, {
    base: '0',
    chars: "\u07C0",
  }, {
    base: 'A',
    chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F",
  }, {
    base: 'AA',
    chars: "\uA732",
  }, {
    base: 'AE',
    chars: "\u00C6\u01FC\u01E2",
  }, {
    base: 'AO',
    chars: "\uA734",
  }, {
    base: 'AU',
    chars: "\uA736",
  }, {
    base: 'AV',
    chars: "\uA738\uA73A",
  }, {
    base: 'AY',
    chars: "\uA73C",
  }, {
    base: 'B',
    chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181",
  }, {
    base: 'C',
    chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B",
  }, {
    base: 'D',
    chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779",
  }, {
    base: 'Dh',
    chars: "\u00D0",
  }, {
    base: 'DZ',
    chars: "\u01F1\u01C4",
  }, {
    base: 'Dz',
    chars: "\u01F2\u01C5",
  }, {
    base: 'E',
    chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07",
  }, {
    base: 'F',
    chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B",
  }, {
    base: 'G',
    chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262",
  }, {
    base: 'H',
    chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D",
  }, {
    base: 'I',
    chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197",
  }, {
    base: 'J',
    chars: "\u24BF\uFF2A\u0134\u0248\u0237",
  }, {
    base: 'K',
    chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2",
  }, {
    base: 'L',
    chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780",
  }, {
    base: 'LJ',
    chars: "\u01C7",
  }, {
    base: 'Lj',
    chars: "\u01C8",
  }, {
    base: 'M',
    chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB",
  }, {
    base: 'N',
    chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E",
  }, {
    base: 'NJ',
    chars: "\u01CA",
  }, {
    base: 'Nj',
    chars: "\u01CB",
  }, {
    base: 'O',
    chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C",
  }, {
    base: 'OE',
    chars: "\u0152",
  }, {
    base: 'OI',
    chars: "\u01A2",
  }, {
    base: 'OO',
    chars: "\uA74E",
  }, {
    base: 'OU',
    chars: "\u0222",
  }, {
    base: 'P',
    chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754",
  }, {
    base: 'Q',
    chars: "\u24C6\uFF31\uA756\uA758\u024A",
  }, {
    base: 'R',
    chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782",
  }, {
    base: 'S',
    chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784",
  }, {
    base: 'T',
    chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786",
  }, {
    base: 'Th',
    chars: "\u00DE",
  }, {
    base: 'TZ',
    chars: "\uA728",
  }, {
    base: 'U',
    chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244",
  }, {
    base: 'V',
    chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245",
  }, {
    base: 'VY',
    chars: "\uA760",
  }, {
    base: 'W',
    chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72",
  }, {
    base: 'X',
    chars: "\u24CD\uFF38\u1E8A\u1E8C",
  }, {
    base: 'Y',
    chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE",
  }, {
    base: 'Z',
    chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762",
  }, {
    base: 'a',
    chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251",
  }, {
    base: 'aa',
    chars: "\uA733",
  }, {
    base: 'ae',
    chars: "\u00E6\u01FD\u01E3",
  }, {
    base: 'ao',
    chars: "\uA735",
  }, {
    base: 'au',
    chars: "\uA737",
  }, {
    base: 'av',
    chars: "\uA739\uA73B",
  }, {
    base: 'ay',
    chars: "\uA73D",
  }, {
    base: 'b',
    chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182",
  }, {
    base: 'c',
    chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184",
  }, {
    base: 'd',
    chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA",
  }, {
    base: 'dh',
    chars: "\u00F0",
  }, {
    base: 'dz',
    chars: "\u01F3\u01C6",
  }, {
    base: 'e',
    chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD",
  }, {
    base: 'f',
    chars: "\u24D5\uFF46\u1E1F\u0192",
  }, {
    base: 'ff',
    chars: "\uFB00",
  }, {
    base: 'fi',
    chars: "\uFB01",
  }, {
    base: 'fl',
    chars: "\uFB02",
  }, {
    base: 'ffi',
    chars: "\uFB03",
  }, {
    base: 'ffl',
    chars: "\uFB04",
  }, {
    base: 'g',
    chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79",
  }, {
    base: 'h',
    chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265",
  }, {
    base: 'hv',
    chars: "\u0195",
  }, {
    base: 'i',
    chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131",
  }, {
    base: 'j',
    chars: "\u24D9\uFF4A\u0135\u01F0\u0249",
  }, {
    base: 'k',
    chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
  }, {
    base: 'l',
    chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D",
  }, {
    base: 'lj',
    chars: "\u01C9",
  }, {
    base: 'm',
    chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F",
  }, {
    base: 'n',
    chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509",
  }, {
    base: 'nj',
    chars: "\u01CC",
  }, {
    base: 'o',
    chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11",
  }, {
    base: 'oe',
    chars: "\u0153",
  }, {
    base: 'oi',
    chars: "\u01A3",
  }, {
    base: 'oo',
    chars: "\uA74F",
  }, {
    base: 'ou',
    chars: "\u0223",
  }, {
    base: 'p',
    chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
  }, {
    base: 'q',
    chars: "\u24E0\uFF51\u024B\uA757\uA759",
  }, {
    base: 'r',
    chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783",
  }, {
    base: 's',
    chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282",
  }, {
    base: 'ss',
    chars: "\xDF",
  }, {
    base: 't',
    chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787",
  }, {
    base: 'th',
    chars: "\u00FE",
  }, {
    base: 'tz',
    chars: "\uA729",
  }, {
    base: 'u',
    chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289",
  }, {
    base: 'v',
    chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C",
  }, {
    base: 'vy',
    chars: "\uA761",
  }, {
    base: 'w',
    chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73",
  }, {
    base: 'x',
    chars: "\u24E7\uFF58\u1E8B\u1E8D",
  }, {
    base: 'y',
    chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF",
  }, {
    base: 'z',
    chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763",
  }
];

var diacriticsMap = {};
for (var i = 0; i < replacementList.length; i += 1) {
  var chars = replacementList[i].chars;
  for (var j = 0; j < chars.length; j += 1) {
    diacriticsMap[chars[j]] = replacementList[i].base;
  }
}

function removeDiacritics(str) {
  return str.replace(/[^\u0000-\u007e]/g, function(c) {
    return diacriticsMap[c] || c;
  });
}

exports.replacementList = replacementList;
exports.diacriticsMap = diacriticsMap;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * StormBox Responsive Autocomplete v3.0.1
 * Created by Mateus Calza.
 * With Inovadora Sistemas support.
 *
 * Licensed MIT.
 */(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.StormBox = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = target[name];
				copy = options[name];

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[name] = extend(deep, clone, copy);

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						target[name] = copy;
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorView = function () {
    function ErrorView(_ref) {
        var style = _ref.style;

        _classCallCheck(this, ErrorView);

        this.elements = {};

        this.elements.wrapper = (0, _dom.div)({ className: style.errorViewWrapper }, this.elements.error = (0, _dom.div)({
            className: style.errorView
        }));

        this.hide();
    }

    _createClass(ErrorView, [{
        key: 'show',
        value: function show(message) {
            this.elements.error.innerText = message;
            this.elements.wrapper.style.display = 'block';
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.elements.wrapper.style.display = 'none';
        }
    }]);

    return ErrorView;
}();

exports.default = ErrorView;

},{"../util/dom":26}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

var _events = require('../util/events');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Icon = function () {
    function Icon(_ref, undefined, autocomplete) {
        var style = _ref.style;

        var _context;

        _classCallCheck(this, Icon);

        this.style = style;
        this.autocomplete = autocomplete;
        this.wasOpen = false;

        this.element = (0, _dom.i)({
            className: style.rightIcon
        });

        (_context = this.element, _events.on).call(_context, 'click', this.click.bind(this));
        (_context = this.element, _events.on).call(_context, 'mousedown', this.mouseDown.bind(this));
    }

    _createClass(Icon, [{
        key: 'mouseDown',
        value: function mouseDown(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.autocomplete.components.panel.components.list.items && this.autocomplete.open) {
                this.autocomplete.closePanel();
            } else if (this.autocomplete.components.panel.components.list.items) {
                this.autocomplete.elements.wrapper.focus();
            }
        }
    }, {
        key: 'click',
        value: function click(event) {
            if (this.autocomplete.components.panel.components.list.items || this.autocomplete.disabled || this.autocomplete.readOnly) {
                return;
            }
            this.autocomplete.forcedSearch = true;
            this.autocomplete.debouncedFind();
            this.autocomplete.elements.wrapper.focus();
        }
    }, {
        key: 'loadingStart',
        value: function loadingStart() {
            this.element.className = this.style.loadingRightIcon;
        }
    }, {
        key: 'loadingStop',
        value: function loadingStop() {
            this.element.className = this.style.rightIcon;
        }
    }]);

    return Icon;
}();

exports.default = Icon;

},{"../util/dom":26,"../util/events":27}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var List = function () {
    function List(_ref, _ref2, autocomplete) {
        var style = _ref.style;
        var onSelect = _ref2.onSelect;

        _classCallCheck(this, List);

        // Initial value
        this.elements = {};
        this.onSelect = onSelect;
        this.autocomplete = autocomplete;
        this.style = style;
        this.items = null;
        this.selectedIndex = 0;
        this.searchInput = null;
        this.lastSelectedIndex = null;

        this.elements.wrapper = (0, _dom.div)({ className: style.listWrapper }, this.elements.ul = (0, _dom.ul)());

        this.hide();
    }

    _createClass(List, [{
        key: 'show',
        value: function show() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            this.lastSelectedIndex = null;
            this.items = items;
            this.elements.wrapper.style.display = 'block';
            this.render();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this = this;

            if (this.items && this.items.length === 0 && this.autocomplete.customText && this.searchInput && this.searchInput.value().trim().length) {
                var searchBarValue = this.searchInput.value().trim();
                var childForCustomText = (0, _dom.div)({
                    className: this.style.item + ' ' + this.style.customTextItem,
                    innerText: searchBarValue
                });
                var liChildForCustomText = (0, _dom.li)({}, childForCustomText);
                this.elements.ul.appendChild(liChildForCustomText);
            }

            if (this.items && this.autocomplete.open) {
                this.autocomplete.components.panel.components.pagination.show();
                this.elements.ul.innerHTML = '';
                this.autocomplete.components.panel.element.style.maxHeight = null;
                this.searchInput = this.autocomplete.components.panel.components.searchInput;

                var length = this.items.length;
                var elementIndex = 0;

                if (this.autocomplete.emptyItem) {
                    var childForEmpty = (0, _dom.div)({
                        className: this.style.item + ' ' + this.style.emptyItem,
                        innerText: this.autocomplete.messages.emptyItemName
                    });
                    this.prepareItemEvents(childForEmpty, { content: null, value: null }, elementIndex);
                    var liChildForEmpty = (0, _dom.li)({}, childForEmpty);
                    this.elements.ul.appendChild(liChildForEmpty);
                    elementIndex++;
                }

                var _childForCustomText = null;
                var _liChildForCustomText = null;
                var _searchBarValue = null;

                if (this.autocomplete.customText && this.searchInput.value().trim().length) {
                    _searchBarValue = this.searchInput.value().trim();
                    _childForCustomText = (0, _dom.div)({
                        className: this.style.item + ' ' + this.style.customTextItem,
                        innerText: _searchBarValue
                    });
                    _liChildForCustomText = (0, _dom.li)({}, _childForCustomText);
                    this.elements.ul.appendChild(_liChildForCustomText);
                }

                var realItemsCount = 0;
                const strRemove = new RegExp('(<b>)|(</b>)', 'g');
                for (var index = this.autocomplete.components.panel.components.pagination.offset; index < length; index++) {
                    var mainText = (0, _dom.span)({
                        innerHTML: this.items[index].content
                    });                
                    let strOrigin= this.items[index].content;
                    this.items[index].content= strOrigin.replace(strRemove, ''); 
                    var additionalChild = null;
                    if (this.items[index].additional && this.items[index].additional.length || typeof this.autocomplete.valueInOthersAs === 'string' || this.autocomplete.showValue) {
                        if (typeof this.autocomplete.valueInOthersAs !== 'string' || !this.autocomplete.showValue) {
                            additionalChild = _dom.div.call.apply(_dom.div, [null, {}].concat(_toConsumableArray(this.items[index].additional.map(function (_ref3) {
                                var label = _ref3.label,
                                    content = _ref3.content;

                                return (0, _dom.div)({ className: _this.style.additional }, (0, _dom.strong)({ innerText: label + ': ' }), (0, _dom.span)({ innerText: content }));
                            }))));
                        } else {
                            additionalChild = _dom.div.call.apply(_dom.div, [null, {}, (0, _dom.div)({ className: this.style.additional }, (0, _dom.strong)({ innerText: this.autocomplete.valueInOthersAs + ': ' }), (0, _dom.span)({ innerText: this.items[index].value }))].concat(_toConsumableArray(this.items[index].additional.map(function (_ref4) {
                                var label = _ref4.label,
                                    content = _ref4.content;

                                return (0, _dom.div)({ className: _this.style.additional }, (0, _dom.strong)({ innerText: label + ': ' }), (0, _dom.span)({ innerText: content }));
                            }))));
                        }
                    }
                    var alreadySelectedIcon = (0, _dom.i)();
                    if (this.autocomplete.multiple && this.autocomplete.value.indexOf(String(this.items[index].value)) !== -1 || !this.autocomplete.multiple && this.autocomplete.value == this.items[index].value) {
                        alreadySelectedIcon.className = this.style.alreadySelected;
                    }
                    var innerChild = (0, _dom.div)({
                        className: this.style.item
                    }, alreadySelectedIcon, mainText);
                    if (additionalChild) {
                        innerChild.appendChild(additionalChild);
                    }
                    this.prepareItemEvents(innerChild, this.items[index], elementIndex);
                    var liChild = (0, _dom.li)({}, innerChild);
                    if (_liChildForCustomText) {
                        this.elements.ul.insertBefore(liChild, _liChildForCustomText);
                    } else {
                        this.elements.ul.appendChild(liChild);
                    }
                    elementIndex++;
                    realItemsCount++;
                    if (this.autocomplete.components.panel.element.getBoundingClientRect().height > this.autocomplete.heightSpace && realItemsCount > this.autocomplete.minItemsLength) {
                        this.elements.ul.removeChild(liChild);
                        elementIndex--;
                        realItemsCount--;
                        break;
                    }
                    this.autocomplete.components.panel.components.pagination.perPage = realItemsCount;
                }

                if (!this.autocomplete.paginationData || this.autocomplete.paginationData.total <= realItemsCount) {
                    this.autocomplete.components.panel.components.pagination.hide();
                }

                if (_childForCustomText) {
                    this.prepareItemEvents(_childForCustomText, { content: _searchBarValue, value: null }, elementIndex);
                    elementIndex++;
                }
                this.autocomplete.components.panel.element.style.maxHeight = Math.max(110, this.autocomplete.heightSpace) + 'px';

                if (this.items.length >= 1) {
                    this.updateSelection(this.lastSelectedIndex !== null ? this.lastSelectedIndex : this.autocomplete.emptyItem ? 1 : 0);
                } else {
                    this.updateSelection(0);
                }
            }
        }
    }, {
        key: 'prepareItemEvents',
        value: function prepareItemEvents(element, data, elementIndex) {
            var _this2 = this;

            element.addEventListener('mouseenter', function (event) {
                _this2.updateSelection(elementIndex);
            });
            element.addEventListener('mousedown', function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this2.updateSelection(elementIndex);
                _this2.onSelect(data);
                if (!_this2.autocomplete.multiple) {
                    _this2.autocomplete.closePanel();
                }
            });
        }
    }, {
        key: 'up',
        value: function up() {
            if (this.elements.ul.children.length) {
                this.updateSelection(this.selectedIndex - 1);
            }
        }
    }, {
        key: 'down',
        value: function down() {
            if (this.elements.ul.children.length) {
                this.updateSelection(this.selectedIndex + 1);
            }
        }
    }, {
        key: 'selectCurrent',
        value: function selectCurrent() {
            if (!this.items) {
                return;
            }
            if (this.autocomplete.emptyItem && this.selectedIndex == 0) {
                this.onSelect({
                    content: null,
                    value: null
                });
            } else if (this.autocomplete.customText && this.selectedIndex == this.elements.ul.children.length - 1 && this.searchInput.value().trim().length) {
                this.onSelect({
                    value: null,
                    content: this.searchInput.value().trim()
                });
            } else if (this.autocomplete.emptyItem) {
                this.onSelect(this.items[this.selectedIndex - 1]);
            } else {
                this.onSelect(this.items[this.selectedIndex]);
            }

            this.autocomplete.closePanel();

            if (document.activeElement != this.autocomplete.elements.wrapper) {
                this.autocomplete.ignoreFocus = true;
                this.autocomplete.elements.wrapper.focus();
            }
        }
    }, {
        key: 'updateSelection',
        value: function updateSelection(index) {
            var currentIndex = this.selectedIndex;
            var children = this.elements.ul.children;
            if (index < 0) {
                return this.autocomplete.components.panel.components.pagination.prev();
            } else if (index > children.length - 1) {
                return this.autocomplete.components.panel.components.pagination.next();
            }
            this.lastSelectedIndex = index;
            this.selectedIndex = index;
            var active = children[currentIndex];
            active && active.children[0].classList.remove('active');
            children[this.selectedIndex].children[0].classList.add('active');
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.elements.wrapper.style.display = 'none';
        }
    }]);

    return List;
}();

exports.default = List;

},{"../util/dom":26}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

var _events = require('../util/events');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Multiple = function () {
    function Multiple(_ref, _ref2, autocomplete) {
        var style = _ref.style;
        var onSelect = _ref2.onSelect;

        _classCallCheck(this, Multiple);

        this.autocomplete = autocomplete;
        this.style = style;
        this.children = {};
        this.children.ul = (0, _dom.ul)({});
        this.element = (0, _dom.div)({ className: style.multipleWrapper }, this.children.ul);
    }

    _createClass(Multiple, [{
        key: 'render',
        value: function render() {
            var _this = this;

            if (!this.autocomplete.hiddenInputName || !this.autocomplete.textInputName) {
                throw new Error('Params "hiddenInputName" and "textInputName" are required when multiple.');
            }
            this.children.ul.innerHTML = '';
            this.autocomplete.value.forEach(function (value, index) {
                var icon = (0, _dom.button)({}, (0, _dom.i)({
                    className: _this.autocomplete.disabled || _this.autocomplete.readOnly ? _this.style.disabledMultipleItemRemoveIcon : _this.style.multipleItemRemoveIcon
                }));
                _events.on.call(icon, 'click', function (event) {
                    event.preventDefault();
                    _this.autocomplete.remove(index);
                });
                var valueElement = (0, _dom.strong)({
                    innerText: value + ': '
                });
                var text = (0, _dom.span)({
                    innerText: _this.autocomplete.content[index]
                });
                var hiddenInput = (0, _dom.input)({
                    type: 'hidden',
                    name: _this.autocomplete.hiddenInputName + '[]',
                    value: value
                });
                var textInput = (0, _dom.input)({
                    type: 'hidden',
                    name: _this.autocomplete.textInputName + '[]',
                    value: _this.autocomplete.content[index]
                });
                var item = void 0;
                if (_this.autocomplete.showValue) {
                    item = (0, _dom.li)({}, icon, valueElement, text, hiddenInput, textInput);
                } else {
                    item = (0, _dom.li)({}, icon, text, hiddenInput, textInput);
                }

                _this.children.ul.appendChild(item);
            });
            if (!this.autocomplete.value.length) {
                this.element.style.display = 'none';
            } else {
                this.element.style.display = 'block';
            }
        }
    }]);

    return Multiple;
}();

exports.default = Multiple;

},{"../util/dom":26,"../util/events":27}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

var _events = require('../util/events');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pagination = function () {
    function Pagination(_ref, _ref2, autocomplete) {
        var style = _ref.style;
        var onSelect = _ref2.onSelect;

        _classCallCheck(this, Pagination);

        this.currentStep = 0;
        this.end = false;
        this.steps = [];
        this.offset = 0;
        this.perPage = Infinity;
        this.autocomplete = autocomplete;
        this.elements = {};

        this.elements.goLeft = (0, _dom.div)({ className: style.paginationLeft }, (0, _dom.i)({ className: style.paginationGoLeftIcon }));

        this.elements.goRight = (0, _dom.div)({ className: style.paginationRight }, (0, _dom.i)({ className: style.paginationGoRightIcon }));

        this.elements.wrapper = (0, _dom.div)({ className: style.paginationWrapper }, this.elements.goLeft, this.elements.goRight);

        this.prepareEvents();
    }

    _createClass(Pagination, [{
        key: 'prepareEvents',
        value: function prepareEvents() {
            var _context,
                _this = this;

            (_context = this.elements.goLeft, _events.on).call(_context, 'mousedown', function (event) {
                event.preventDefault();
                _this.prev();
                _this.autocomplete.components.panel.components.searchInput.elements.input.focus();
            });
            (_context = this.elements.goRight, _events.on).call(_context, 'mousedown', function (event) {
                event.preventDefault();
                _this.next();
                _this.autocomplete.components.panel.components.searchInput.elements.input.focus();
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.elements.wrapper.style.display = 'none';
        }
    }, {
        key: 'show',
        value: function show() {
            this.elements.wrapper.style.display = 'block';
        }
    }, {
        key: 'next',
        value: function next() {
            var _this2 = this;

            var items = this.autocomplete.components.panel.components.list.items;
            if (typeof items[this.offset + this.perPage] === 'undefined') {
                if (this.end) {
                    return;
                }
                this.feed(this.offset + this.perPage).then(function (newItems) {
                    if (!newItems.length) {
                        _this2.end = true;
                    } else {
                        //items.push.apply(items, newItems);
                        var changed = false;
                        newItems.forEach(function (item) {
                            if (!items.some(function (_item) {
                                return JSON.stringify(_item) === JSON.stringify(item);
                            })) {
                                items.push(item);

                                changed = true;
                            }
                        });
                        if (changed) {
                            _this2.currentStep++;
                            _this2.offset = _this2.steps[_this2.currentStep] = _this2.offset + _this2.perPage;
                        }
                        
                        _this2.autocomplete.components.panel.components.list.render();
                    }
                });
            } else {
                this.currentStep++;
                this.offset = this.steps[this.currentStep] = this.offset + this.perPage;
                this.autocomplete.components.panel.components.list.render();
            }
        }
    }, {
        key: 'prev',
        value: function prev() {
            if (this.currentStep === 0) {
                return;
            }
            this.currentStep--;
            this.offset = this.steps[this.currentStep] || 0;
            this.autocomplete.components.panel.components.list.render();
        }
    }, {
        key: 'feed',
        value: function feed(offset) {
            return this.autocomplete.feed(offset);
        }
    }]);

    return Pagination;
}();

exports.default = Pagination;

},{"../util/dom":26,"../util/events":27}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StormBox = require('../components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

var _SearchInput = require('./SearchInput');

var _SearchInput2 = _interopRequireDefault(_SearchInput);

var _ErrorView = require('./ErrorView');

var _ErrorView2 = _interopRequireDefault(_ErrorView);

var _WarningView = require('./WarningView');

var _WarningView2 = _interopRequireDefault(_WarningView);

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Pagination = require('./Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _dom = require('../util/dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Panel = function () {
    function Panel(_ref, _ref2, autocomplete) {
        var style = _ref.style;
        var onSelect = _ref2.onSelect;

        _classCallCheck(this, Panel);

        this.autocomplete = autocomplete;
        this.components = {
            searchInput: new _SearchInput2.default({ style: style }, undefined, autocomplete),
            errorView: new _ErrorView2.default({ style: style }),
            warningView: new _WarningView2.default({ style: style }),
            list: new _List2.default({ style: style }, { onSelect: onSelect }, autocomplete),
            pagination: new _Pagination2.default({ style: style }, { onSelect: onSelect }, autocomplete)
        };

        this.element = (0, _dom.div)({
            className: style.panel
        }, this.components.searchInput.elements.wrapper, this.components.errorView.elements.wrapper, this.components.warningView.elements.wrapper, this.components.pagination.elements.wrapper, this.components.list.elements.wrapper);
    }

    _createClass(Panel, [{
        key: 'show',
        value: function show(results) {
            if (results.data.length === 0) {
                this.warning({
                    message: this.autocomplete.messages.noData
                });

                if (!this.autocomplete.customText) {
                    return;
                }
            }

            this.components.pagination.currentStep = 0;
            this.components.pagination.offset = 0;
            this.components.pagination.perPage = Infinity;
            this.components.list.show(results.data);
        }
    }, {
        key: 'error',
        value: function error(_error) {
            this.components.list.hide();
            this.components.warningView.hide();
            console.error(_error);
            this.components.errorView.show(_StormBox2.default.truncate(_StormBox2.default.responseToText(_error.message)));
        }
    }, {
        key: 'warning',
        value: function warning(_warning) {
            this.components.list.hide();
            this.components.errorView.hide();
            this.components.warningView.show(_StormBox2.default.truncate(_StormBox2.default.responseToText(_warning.message)));
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.components.errorView.hide();
            this.components.warningView.hide();
            this.components.list.hide();
        }
    }]);

    return Panel;
}();

exports.default = Panel;

},{"../components/StormBox":10,"../util/dom":26,"./ErrorView":2,"./List":4,"./Pagination":6,"./SearchInput":9,"./WarningView":11}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

var _events = require('../util/events');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PresentText = function () {
    function PresentText(_ref, undefined, autocomplete) {
        var _ref$style = _ref.style,
            presentText = _ref$style.presentText,
            presentInnerText = _ref$style.presentInnerText,
            presentCropText = _ref$style.presentCropText,
            presentInnerValue = _ref$style.presentInnerValue,
            presentTextItems = _ref$style.presentTextItems;

        var _context;

        _classCallCheck(this, PresentText);

        this.autocomplete = autocomplete;
        this.elements = {};

        this.elements.inner = (0, _dom.div)({
            className: presentInnerText
        });

        this.elements.innerValue = (0, _dom.div)({
            className: presentInnerValue
        });

        this.elements.items = (0, _dom.div)({
            className: presentTextItems
        }, this.elements.innerValue, this.elements.inner);

        this.elements.crop = (0, _dom.div)({
            className: presentCropText
        }, this.elements.items);

        (_context = (_context = this.autocomplete.elements.wrapper, _events.on).call(_context, 'mouseenter', this.scrollToShow.bind(this)), _events.on).call(_context, 'mouseleave', this.scrollToHide.bind(this));

        this.element = (0, _dom.div)({
            className: presentText
        }, this.elements.crop);
    }

    _createClass(PresentText, [{
        key: 'scrollToShow',
        value: function scrollToShow() {
            if (!this.autocomplete.open) {
                // Prepare transition
                this.elements.items.style.webkitTransition = 'left linear 3s';
                this.elements.items.style.mozTransition = 'left linear 3s';
                this.elements.items.style.oTransition = 'left linear 3s';
                this.elements.items.style.transition = 'left linear 3s';

                // Floor and set min as 0 to diff between crop width and sum innerText width with innerValue
                this.elements.items.style.left = '-' + Math.max(0, Math.floor((this.elements.innerValue.style.display === 'none' ? 0 : this.elements.innerValue.getBoundingClientRect().width) + this.elements.inner.getBoundingClientRect().width - this.elements.crop.getBoundingClientRect().width)) + 'px';
            }
        }
    }, {
        key: 'scrollToHide',
        value: function scrollToHide(event) {
            // Prepare transition
            this.elements.items.style.webkitTransition = 'left linear 600ms';
            this.elements.items.style.mozTransition = 'left linear 600ms';
            this.elements.items.style.oTransition = 'left linear 600ms';
            this.elements.items.style.transition = 'left linear 600ms';

            // Return transition
            this.elements.items.style.left = '0px';
        }
    }, {
        key: 'text',
        value: function text(_text) {
            this.elements.inner.innerText = _text;
        }
    }, {
        key: 'value',
        value: function value() {
            var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (this.autocomplete.showValue && String(_value).length) {
                this.elements.innerValue.innerText = _value;
                this.elements.innerValue.style.display = 'inline-block';
            } else {
                this.elements.innerValue.style.display = 'none';
            }
        }
    }]);

    return PresentText;
}();

exports.default = PresentText;

},{"../util/dom":26,"../util/events":27}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = require('extend');

var _extend2 = _interopRequireDefault(_extend);

var _SelectSource = require('../sources/SelectSource');

var _SelectSource2 = _interopRequireDefault(_SelectSource);

var _dom = require('../util/dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchInput = function () {
    function SearchInput(_ref, undefined, autocomplete) {
        var style = _ref.style;

        _classCallCheck(this, SearchInput);

        this.elements = {};

        this.elements.input = (0, _dom.input)({
            className: style.searchInput,
            placeholder: autocomplete.messages.searchPlaceholder
        });

        this.elements.wrapper = (0, _dom.div)({ className: style.searchInputWrapper }, this.elements.input);
    }

    _createClass(SearchInput, [{
        key: 'value',
        value: function value(setValue) {
            if (typeof setValue !== 'undefined') {
                this.elements.input.value = setValue;
                return this;
            }

            return this.elements.input.value;
        }
    }]);

    return SearchInput;
}();

exports.default = SearchInput;

},{"../sources/SelectSource":23,"../util/dom":26,"extend":1}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = require('extend');

var _extend2 = _interopRequireDefault(_extend);

var _PresentText = require('./PresentText');

var _PresentText2 = _interopRequireDefault(_PresentText);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Multiple = require('./Multiple');

var _Multiple2 = _interopRequireDefault(_Multiple);

var _Panel = require('./Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _SelectSource = require('../sources/SelectSource');

var _SelectSource2 = _interopRequireDefault(_SelectSource);

var _Core = require('../core/Core');

var _Core2 = _interopRequireDefault(_Core);

var _Events = require('../mixins/Events');

var _Events2 = _interopRequireDefault(_Events);

var _Finding = require('../mixins/Finding');

var _Finding2 = _interopRequireDefault(_Finding);

var _PanelControl = require('../mixins/PanelControl');

var _PanelControl2 = _interopRequireDefault(_PanelControl);

var _Selecting = require('../mixins/Selecting');

var _Selecting2 = _interopRequireDefault(_Selecting);

var _Positioning = require('../mixins/Positioning');

var _Positioning2 = _interopRequireDefault(_Positioning);

var _Replica = require('../mixins/Replica');

var _Replica2 = _interopRequireDefault(_Replica);

var _Interface = require('../mixins/Interface');

var _Interface2 = _interopRequireDefault(_Interface);

var _debounce = require('../util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _dom = require('../util/dom');

var _use2 = require('../util/use');

var _use3 = _interopRequireDefault(_use2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StormBox = function (_use) {
    _inherits(StormBox, _use);

    function StormBox(options) {
        _classCallCheck(this, StormBox);

        var hiddenInput = options.hiddenInput,
            textInput = options.textInput,
            source = options.source,
            selectInput = options.selectInput,
            _options$style = options.style,
            style = _options$style === undefined ? {} : _options$style,
            _options$customText = options.customText,
            customText = _options$customText === undefined ? false : _options$customText,
            _options$debounceTime = options.debounceTime,
            debounceTime = _options$debounceTime === undefined ? 600 : _options$debounceTime,
            _options$queryParam = options.queryParam,
            queryParam = _options$queryParam === undefined ? 'q' : _options$queryParam,
            _options$minLength = options.minLength,
            minLength = _options$minLength === undefined ? 1 : _options$minLength,
            _options$clearOnType = options.clearOnType,
            clearOnType = _options$clearOnType === undefined ? false : _options$clearOnType,
            _options$autoFind = options.autoFind,
            autoFind = _options$autoFind === undefined ? false : _options$autoFind,
            _options$autoSelectWh = options.autoSelectWhenOneResult,
            autoSelectWhenOneResult = _options$autoSelectWh === undefined ? true : _options$autoSelectWh,
            emptyItem = options.emptyItem,
            _options$messages = options.messages,
            messages = _options$messages === undefined ? {} : _options$messages,
            _options$references = options.references,
            references = _options$references === undefined ? {} : _options$references,
            _options$otherParams = options.otherParams,
            otherParams = _options$otherParams === undefined ? {} : _options$otherParams,
            _options$showValue = options.showValue,
            showValue = _options$showValue === undefined ? true : _options$showValue,
            _options$valueInOther = options.valueInOthersAs,
            valueInOthersAs = _options$valueInOther === undefined ? 'ID' : _options$valueInOther,
            _options$minItemsLeng = options.minItemsLength,
            minItemsLength = _options$minItemsLeng === undefined ? 1 : _options$minItemsLeng,
            _options$multiple = options.multiple,
            multiple = _options$multiple === undefined ? false : _options$multiple,
            _options$anchorElemen = options.anchorElement,
            anchorElement = _options$anchorElemen === undefined ? null : _options$anchorElemen,
            _options$distinct = options.distinct,
            distinct = _options$distinct === undefined ? true : _options$distinct,
            _options$hiddenInputN = options.hiddenInputName,
            hiddenInputName = _options$hiddenInputN === undefined ? null : _options$hiddenInputN,
            _options$textInputNam = options.textInputName,
            textInputName = _options$textInputNam === undefined ? null : _options$textInputNam,
            _options$softErrors = options.softErrors,
            softErrors = _options$softErrors === undefined ? false : _options$softErrors,
            _options$disabled = options.disabled,
            disabled = _options$disabled === undefined ? false : _options$disabled,
            _options$readOnly = options.readOnly,
            readOnly = _options$readOnly === undefined ? false : _options$readOnly;

        // Key
        var _this = _possibleConstructorReturn(this, (StormBox.__proto__ || Object.getPrototypeOf(StormBox)).call(this, options));

        _this.key = StormBox.currentSerialKey++;

        // Environment
        _this.finding = false;
        _this.open = false;
        _this.typing = false;
        _this.ignoreFocus = false;
        _this.ignoreBlur = false;
        _this.lastParams = null;
        _this.forcedSearch = false;
        _this.valueOnOpen = undefined;
        _this.usedOtherFields = [];
        _this.paginationData = null;
        _this.direction = 'down';

        // Initial
        _this.disabled = disabled;
        _this.readOnly = readOnly;
        _this.multiple = multiple;
        _this.distinct = distinct;
        _this.anchorElement = anchorElement;
        _this.references = references;
        _this.otherParams = otherParams;
        _this.queryParam = queryParam;
        _this.clearOnType = clearOnType;
        _this.autoFind = autoFind;
        _this.minLength = minLength;
        _this.showValue = showValue;
        _this.customText = customText;
        _this.softErrors = softErrors;
        _this.autoSelectWhenOneResult = autoSelectWhenOneResult;
        _this.valueInOthersAs = valueInOthersAs;
        _this.minItemsLength = minItemsLength;
        _this.hiddenInputName = hiddenInputName;
        _this.textInputName = textInputName;
        _this.emptyItem = emptyItem;
        if (multiple) {
            _this.emptyItem = false;
        }

        // Source validation
        if (!source && !selectInput) {
            throw new Error('Set a source or a selectInput.');
        }

        // Set data source
        _this.source = source || new _SelectSource2.default(selectInput);

        // Set style props
        _this.style = (0, _extend2.default)({
            hiddenInput: 'ac-hidden-input',
            textInput: 'ac-text-input',
            panel: 'ac-panel',
            listWrapper: 'ac-list-wrapper',
            item: 'ac-item',
            emptyItem: 'ac-empty-item',
            customTextItem: 'ac-custom-text-item',
            additional: 'ac-additional',
            searchInput: 'ac-search-input',
            searchInputWrapper: 'ac-search-input-wrapper',
            presentText: 'ac-present-text',
            presentCropText: 'ac-present-crop-text',
            presentTextItems: 'ac-present-items',
            presentInnerText: 'ac-present-inner-text',
            presentInnerValue: 'ac-present-inner-value',
            errorView: 'ac-error-view',
            errorViewWrapper: 'ac-error-view-wrapper',
            warningView: 'ac-warning-view',
            warningViewWrapper: 'ac-warning-view-wrapper',
            wrapper: 'ac-wrapper',
            top: 'ac-top',
            bottom: 'ac-bottom',
            openWrapper: 'ac-wrapper ac-open-wrapper',
            disabledWrapper: 'ac-wrapper ac-disabled-wrapper',
            readOnlyWrapper: 'ac-wrapper ac-read-only-wrapper',
            rightIcon: 'fa fa-search ac-icon',
            loadingRightIcon: 'fa fa-spinner ac-icon ac-loading-icon',
            disabledRightIcon: 'fa fa-ban ac-icon',
            readOnlyRightIcon: 'fa fa-info ac-icon',
            paginationWrapper: 'ac-pagination-wrapper',
            paginationLeft: 'ac-pagination-left',
            paginationRight: 'ac-pagination-right',
            paginationGoLeftIcon: 'fa fa-chevron-left',
            paginationGoRightIcon: 'fa fa-chevron-right',
            multipleWrapper: 'ac-multiple',
            multipleItemRemoveIcon: 'fa fa-remove ac-multiple-remove',
            disabledMultipleItemRemoveIcon: 'fa fa-remove ac-multiple-remove ac-multiple-remove-disabled',
            alreadySelected: 'fa fa-check-circle ac-already-selected'
        }, style);

        _this.messages = (0, _extend2.default)({
            searchPlaceholder: 'Search...',
            emptyItemName: 'No value',
            singularMultipleItems: 'item',
            pluralMultipleItems: 'items',
            noData: 'No items'
        }, messages);

        // Set StormBox's elements
        _this.elements = {
            hiddenInput: hiddenInput,
            textInput: textInput,
            wrapper: (0, _dom.div)({
                className: _this.style.wrapper
            }),
            label: null
        };

        // Debouncing find
        _this.debouncedFind = (0, _debounce2.default)(_this.find.bind(_this), debounceTime);
        // Debouncing layout change
        _this.debouncedLayoutChange = (0, _debounce2.default)(_this.layoutChange.bind(_this), 250);

        // Set relative components
        _this.components = {
            presentText: new _PresentText2.default({ style: _this.style }, {}, _this),
            icon: new _Icon2.default({ style: _this.style }, {}, _this),
            panel: new _Panel2.default({ style: _this.style }, { onSelect: _this.select.bind(_this) }, _this),
            multiple: new _Multiple2.default({ style: _this.style }, { onRemove: _this.remove.bind(_this) }, _this)
        };

        // Prepare elements
        _this.prepareElements();
        return _this;
    }

    _createClass(StormBox, [{
        key: 'prepareElements',
        value: function prepareElements() {
            // Turn wrapper focusable
            this.elements.wrapper.setAttribute('tabindex', '0');
            this.elements.wrapper.autoComplete = this;
            if (!this.multiple) {
                // Store hiddenInput value
                this.value = this.elements.hiddenInput.value;
                // Store textInput value (content)
                this.content = this.elements.textInput.value;

                // If no anchor, textInput is anchor
                if (!this.anchorElement) {
                    this.anchorElement = this.elements.textInput;
                }

                // Find label
                this.elements.label = StormBox.findLabel(this.anchorElement) || null;

                // Add wrapper after anchor
                this.anchorElement.parentNode.insertBefore(this.elements.wrapper, this.anchorElement.nextSibling);

                // Clone props and observe set
                this.relatedReplica();

                // Remove old inputs
                this.elements.hiddenInput.parentNode.removeChild(this.elements.hiddenInput);
                this.elements.textInput.parentNode.removeChild(this.elements.textInput);

                if (this.anchorElement.parentNode) {
                    this.anchorElement.parentNode.removeChild(this.anchorElement);
                }

                // Prepare hiddenInput
                this.elements.hiddenInput.autoComplete = this;
                this.elements.hiddenInput.type = 'hidden';
                this.elements.hiddenInput.className = this.style.hiddenInput;
                this.elements.hiddenInput.dataset['autocompleteKey'] = this.key;
                // Prepare textInput
                this.elements.textInput.autoComplete = this;
                this.elements.textInput.type = 'hidden';
                this.elements.textInput.className = this.style.textInput;
                this.elements.textInput.dataset['autocompleteTextKey'] = this.key;

                // Present values
                this.components.presentText.value(this.value);
                this.components.presentText.text(this.content);

                // Put hiddens in DOM
                this.elements.wrapper.appendChild(this.elements.hiddenInput);
                this.elements.wrapper.appendChild(this.elements.textInput);

                // Append wrapper's children
                this.elements.wrapper.appendChild(this.components.presentText.element);
                this.elements.wrapper.appendChild(this.components.icon.element);
                this.elements.wrapper.appendChild(this.components.panel.element);
            } else {
                // Store hiddenInput value
                this.value = this.elements.hiddenInput.map(function (element) {
                    return element.value;
                });
                // Store textInput value (content)
                this.content = this.elements.textInput.map(function (element) {
                    return element.value;
                });

                // If no anchor, first textInput is anchor
                if (!this.anchorElement && this.elements.textInput[0]) {
                    this.anchorElement = this.elements.textInput[0];
                }

                // If still no anchor, throw error
                if (!this.anchorElement) {
                    throw new Error('StormBox anchor element missing!');
                }

                // Find label
                this.elements.label = StormBox.findLabel(this.anchorElement) || null;

                // Add wrapper after anchor
                this.anchorElement.parentNode.insertBefore(this.elements.wrapper, this.elements.textInput.nextSibling);

                // Clone props and observe set
                this.relatedReplica();

                // Remove items from DOM
                this.elements.hiddenInput.forEach(function (element) {
                    return element.parentNode.removeChild(element);
                });
                this.elements.textInput.forEach(function (element) {
                    return element.parentNode.removeChild(element);
                });

                if (this.anchorElement.parentNode) {
                    this.anchorElement.parentNode.removeChild(this.anchorElement);
                }

                // Present values
                this.components.presentText.value('');
                if (this.value.length === 1) {
                    this.components.presentText.text(this.value.length + ' ' + this.messages.singularMultipleItems);
                } else if (this.value.length > 1) {
                    this.components.presentText.text(this.value.length + ' ' + this.messages.pluralMultipleItems);
                } else {
                    this.components.presentText.text(' ');
                }
                this.components.multiple.render();

                // Append wrapper's children
                this.elements.wrapper.appendChild(this.components.presentText.element);
                this.elements.wrapper.appendChild(this.components.icon.element);
                this.elements.wrapper.appendChild(this.components.panel.element);
                this.elements.wrapper.parentNode.insertBefore(this.components.multiple.element, this.elements.wrapper.nextSibling);
            }
            this.prepareEvents();
        }
    }, {
        key: 'relatedApply',
        value: function relatedApply(fn) {
            if (!StormBox.isArray(this.elements.textInput)) {
                fn(this.elements.textInput);
            } else {
                this.elements.textInput.forEach(function (element) {
                    return fn(element);
                });
            }

            if (!StormBox.isArray(this.elements.hiddenInput)) {
                fn(this.elements.hiddenInput);
            } else {
                this.elements.hiddenInput.forEach(function (element) {
                    return fn(element);
                });
            }

            if (this.anchorElement != this.elements.textInput && this.anchorElement != this.elements.hiddenInput) {
                fn(this.anchorElement);
            }
        }
    }, {
        key: 'setIdValue',
        value: function setIdValue(value) {
            this.elements.hiddenInput.value = value;
        }
    }, {
        key: 'setTextValue',
        value: function setTextValue(value) {
            this.elements.textInput.value = value;
        }
    }, {
        key: 'setIdPresentValue',
        value: function setIdPresentValue(value) {
            this.components.presentText.value(value);
        }
    }, {
        key: 'setTextPresentValue',
        value: function setTextPresentValue(value) {
            this.components.presentText.text(value);
        }
    }, {
        key: 'getIdValue',
        value: function getIdValue() {
            return this.elements.hiddenInput.value;
        }
    }, {
        key: 'getTextValue',
        value: function getTextValue() {
            return this.elements.textInput.value;
        }
    }]);

    return StormBox;
}((0, _use3.default)(_Core2.default, _Events2.default, _Positioning2.default, _Finding2.default, _PanelControl2.default, _Selecting2.default, _Interface2.default, _Replica2.default));

exports.default = StormBox;

},{"../core/Core":12,"../mixins/Events":14,"../mixins/Finding":15,"../mixins/Interface":16,"../mixins/PanelControl":17,"../mixins/Positioning":18,"../mixins/Replica":19,"../mixins/Selecting":20,"../sources/SelectSource":23,"../util/debounce":25,"../util/dom":26,"../util/use":29,"./Icon":3,"./Multiple":5,"./Panel":7,"./PresentText":8,"extend":1}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom = require('../util/dom');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WarningView = function () {
    function WarningView(_ref) {
        var style = _ref.style;

        _classCallCheck(this, WarningView);

        this.elements = {};

        this.elements.wrapper = (0, _dom.div)({ className: style.warningViewWrapper }, this.elements.warning = (0, _dom.div)({
            className: style.warningView
        }));

        this.hide();
    }

    _createClass(WarningView, [{
        key: 'show',
        value: function show(message) {
            this.elements.warning.innerText = message;
            this.elements.wrapper.style.display = 'block';
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.elements.wrapper.style.display = 'none';
        }
    }]);

    return WarningView;
}();

exports.default = WarningView;

},{"../util/dom":26}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StormBox = require('../components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

var _dom = require('../util/dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Core = function () {
    function Core() {
        _classCallCheck(this, Core);
    }

    _createClass(Core, null, [{
        key: 'byId',
        value: function byId(id) {
            var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

            return doc.getElementById(id);
        }
    }, {
        key: 'byName',
        value: function byName(name) {
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

            var nodeListWithName = (this instanceof HTMLElement ? this : doc).getElementsByName(name);
            if (!nodeListWithName.length || !nodeListWithName[index]) {
                return null;
            }
            return nodeListWithName[index];
        }
    }, {
        key: 'byArrayName',
        value: function byArrayName(name) {
            var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

            return Array.prototype.slice.call((this instanceof HTMLElement ? this : doc).getElementsByName(name + '[]'));
        }
    }, {
        key: 'allByName',
        value: function allByName(name) {
            var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

            return Array.prototype.slice.call((this instanceof HTMLElement ? this : doc).getElementsByName(name));
        }
    }, {
        key: 'autoCompleteByKey',
        value: function autoCompleteByKey(autocompleteKey) {
            var element = document.querySelector('[data-autocomplete-key="' + autocompleteKey + '"]');
            if (!element) {
                return null;
            }
            if (!element.autoComplete) {
                throw new Error('Field is not an autocomplete!', element);
            }
            return element.autoComplete;
        }
    }, {
        key: 'isFrom',
        value: function isFrom(target, canditateParent) {
            while (target) {
                if (target === canditateParent) return true;
                target = target.parentNode;
            }
            return false;
        }
    }, {
        key: 'findLabel',
        value: function findLabel(target) {
            var label = void 0;
            if (target.id && (label = document.querySelector('label[for="' + target.id + '"]'))) {
                return label;
            }

            var iterations = 0;
            while (target) {
                if (++iterations > 3) return false;
                if (target.tagName === 'LABEL') return target;
                target = target.parentNode;
            }
            return false;
        }
    }, {
        key: 'autoCompleteByName',
        value: function autoCompleteByName(name) {
            var element = _StormBox2.default.byName(name);
            if (!element) {
                return null;
            }
            if (!element.autoComplete) {
                throw new Error('Field is not an autocomplete!', element);
            }
            return element.autoComplete;
        }
    }, {
        key: 'responseToText',
        value: function responseToText(response) {
            return (0, _dom.div)({ innerHTML: response }).innerText.replace(/[\n\r]/g, ' ');
        }
    }, {
        key: 'truncate',
        value: function truncate(text) {
            var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 320;

            text = String(text).trim();
            if (text.length > maxLength) {
                return text.substr(0, maxLength) + '...';
            }
            return text;
        }
    }, {
        key: 'interpret',
        value: function interpret(mixedValue) {
            if (mixedValue === 'true') {
                return true;
            } else if (mixedValue === 'false') {
                return false;
            } else if (!isNaN(mixedValue)) {
                return +mixedValue;
            } else {
                return mixedValue;
            }
        }
    }, {
        key: 'isArray',
        value: function isArray(anyVariable) {
            if (Object.prototype.toString.call(anyVariable) === '[object Array]') {
                return true;
            }
            return false;
        }
    }, {
        key: 'projectElementSettings',
        value: function projectElementSettings(element, _ref) {
            var content = _ref.content,
                value = _ref.value,
                disabled = _ref.disabled,
                readonly = _ref.readonly,
                required = _ref.required,
                visibility = _ref.visibility,
                removed = _ref.removed;

            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref2$defaultDisplayS = _ref2.defaultDisplayShow,
                defaultDisplayShow = _ref2$defaultDisplayS === undefined ? 'inline-block' : _ref2$defaultDisplayS;

            var softErrors = arguments[2];


            // Value
            if (typeof value === 'undefined' && typeof element.dataset['oldValue'] !== 'undefined') {
                value = element.dataset['oldValue'];
            }
            if (typeof value !== 'undefined') {
                if (element.getAttribute('type') === 'checkbox') {
                    if (typeof element.dataset['oldValue'] === 'undefined') {
                        element.dataset['oldValue'] = element.checked;
                    }
                    element.checked = _StormBox2.default.interpret(value);
                } else if (element.getAttribute('type') === 'radio') {
                    if (typeof element.dataset['oldValue'] === 'undefined') {
                        var currentValue = _StormBox2.default.allByName(element.name).filter(function (element) {
                            return element.checked;
                        });

                        element.dataset['oldValue'] = currentValue[0] ? currentValue[0].value : NaN;
                    }

                    var matchItems = _StormBox2.default.allByName(element.name);

                    matchItems.forEach(function (element) {
                        element.checked = false;
                        return element;
                    });

                    matchItems.filter(function (element) {
                        return element.value == value;
                    }).forEach(function (element) {
                        element.checked = true;
                    });
                } else {
                    if (typeof element.dataset['oldValue'] === 'undefined') {
                        element.dataset['oldValue'] = element.value;
                    }
                    element.value = value;
                }
                if (typeof element.autoComplete !== 'undefined') {
                    element.autoComplete.components.presentText.value(value || '');
                    element.autoComplete.value = value;
                }
            }

            // Disabled
            if (typeof disabled === 'undefined' && typeof element.dataset['oldDisabled'] !== 'undefined') {
                disabled = _StormBox2.default.interpret(element.dataset['oldDisabled']);
            }
            if (typeof disabled !== 'undefined') {
                if (typeof element.dataset['oldDisabled'] === 'undefined') {
                    element.dataset['oldDisabled'] = !!element.disabled;
                }
                element.disabled = disabled;
                if (typeof element.autoComplete !== 'undefined') {
                    if (disabled) {
                        element.autoComplete.disable();
                    } else {
                        element.autoComplete.enable();
                    }
                }
            }

            // ReadOnly
            if (typeof readonly === 'undefined' && typeof element.dataset['oldReadOnly'] !== 'undefined') {
                readonly = _StormBox2.default.interpret(element.dataset['oldReadOnly']);
            }
            if (typeof readonly !== 'undefined') {
                if (typeof element.dataset['oldReadOnly'] === 'undefined') {
                    element.dataset['oldReadOnly'] = !!element.readonly;
                }
                element.readOnly = readonly;
                if (typeof element.autoComplete !== 'undefined') {
                    if (readonly) {
                        element.autoComplete.canRead();
                    } else {
                        element.autoComplete.canReadAndWrite();
                    }
                }
            }

            // Required
            if (typeof required === 'undefined' && typeof element.dataset['oldRequired'] !== 'undefined') {
                required = _StormBox2.default.interpret(element.dataset['oldRequired']);
            }
            if (typeof required !== 'undefined') {
                if (typeof element.dataset['oldRequired'] === 'undefined') {
                    element.dataset['oldRequired'] = element.required;
                }
                element.required = required;
                if (typeof element.autoComplete !== 'undefined') {
                    if (required) {
                        element.autoComplete.required();
                    } else {
                        element.autoComplete.optional();
                    }
                }
            }

            // Visibility
            if (typeof visibility === 'undefined' && typeof element.dataset['oldVisibility'] !== 'undefined') {
                visibility = _StormBox2.default.interpret(element.dataset['oldVisibility']);
            }
            if (typeof visibility !== 'undefined') {
                if (typeof element.dataset['oldVisibility'] === 'undefined') {
                    element.dataset['oldVisibility'] = element.style.display !== 'none';
                }
                element.style.display = visibility ? defaultDisplayShow : 'none';
                if (typeof element.autoComplete !== 'undefined' && _StormBox2.default.isArray(element.autoComplete.elements.textInput)) {
                    element.autoComplete.elements.textInput.forEach(function (textInput) {
                        textInput.style.display = visibility ? defaultDisplayShow : 'none';
                    });
                } else if (typeof element.autoComplete !== 'undefined') {
                    element.autoComplete.elements.textInput.style.display = visibility ? defaultDisplayShow : 'none';
                }
            }

            // Content
            if (typeof content === 'undefined' && typeof element.dataset['oldContent'] !== 'undefined') {
                content = element.dataset['oldContent'];
            }
            if (typeof content !== 'undefined') {
                var textElement = document.querySelector('[data-autocomplete-text-key="' + element.dataset.autocompleteKey + '"]');
                if (!textElement) {
                    if (softErrors) {
                        return console.warn('Unknow text element to ', element);
                    } else {
                        throw new Error('Unknow text element to ', element);
                    }
                }
                if (typeof element.dataset['oldContent'] === 'undefined') {
                    element.dataset['oldContent'] = textElement.value;
                }
                textElement.autoComplete.content = content;
                textElement.autoComplete.components.presentText.text(content || ' ');
                textElement.value = content;
            }

            // Remove (irreversible)
            if (removed == true) {
                element.parentNode.removeChild(element);
            }
        }
    }]);

    return Core;
}();

Core.currentSerialKey = 0;
exports.default = Core;


window.isFrom = Core.isFrom;

},{"../components/StormBox":10,"../util/dom":26}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _StormBox = require('./components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

var _Source = require('./sources/Source');

var _Source2 = _interopRequireDefault(_Source);

var _AjaxSource = require('./sources/AjaxSource');

var _AjaxSource2 = _interopRequireDefault(_AjaxSource);

var _SelectSource = require('./sources/SelectSource');

var _SelectSource2 = _interopRequireDefault(_SelectSource);

var _ArraySource = require('./sources/ArraySource');

var _ArraySource2 = _interopRequireDefault(_ArraySource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_StormBox2.default.AjaxSource = _AjaxSource2.default; /**
                                                       * ES7 AutoComplete
                                                       *
                                                       * @author Jackson Veroneze <jackson@inovadora.com.br>
                                                       * @author Ladislau Perrony <ladislau.perrony@inovadora.com.br>
                                                       * @author Mario Mendonça <mario@inovadora.com.br>
                                                       * @author Mateus Calza <mateus@inovadora.com.br>
                                                       * @author Patrick Nascimento <patrick@inovadora.com.br>
                                                       * @license MIT
                                                       * @version 1.0.0
                                                       */

_StormBox2.default.SelectSource = _SelectSource2.default;
_StormBox2.default.ArraySource = _ArraySource2.default;

_StormBox2.default.abstracts = {
    Source: _Source2.default
};

exports.default = _StormBox2.default;


if (typeof window !== 'undefined') {
    window.StormBoxWidget = _StormBox2.default;
}

},{"./components/StormBox":10,"./sources/AjaxSource":21,"./sources/ArraySource":22,"./sources/SelectSource":23,"./sources/Source":24}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StormBox = require('../components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

var _events = require('../util/events');

var _keys = require('../util/keys');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ignoredKeysOnSearch = [_keys.ENTER, _keys.ARROW_DOWN, _keys.ARROW_UP, _keys.ARROW_LEFT, _keys.ARROW_RIGHT, _keys.SHIFT, _keys.TAB];

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'prepareEvents',
            value: function prepareEvents() {
                var _context;

                (_context = this.components.presentText.element, _events.on).call(_context, 'click', this.iconOrTextClick.bind(this));
                (_context = this.components.icon.element, _events.on).call(_context, 'click', this.iconOrTextClick.bind(this));
                (_context = this.elements.wrapper, _events.on).call(_context, 'keyup', this.keyUp.bind(this));
                (_context = this.elements.wrapper, _events.on).call(_context, 'keydown', this.keyDown.bind(this));
                (_context = this.elements.wrapper, _events.on).call(_context, 'focus', this.wrapperFocus.bind(this));
                (_context = this.elements.wrapper, _events.on).call(_context, 'mousedown', this.wrapperMouseDown.bind(this));
                (_context = this.elements.wrapper, _events.on).call(_context, 'blur', this.blur.bind(this));
                (_context = this.components.panel.components.searchInput.elements['input'], _events.on).call(_context, 'blur', this.blur.bind(this));
                (_context = window, _events.on).call(_context, 'scroll', this.scroll.bind(this));
                (_context = window, _events.on).call(_context, 'resize', this.resize.bind(this));
                this.elements.label && (_context = this.elements.label, _events.on).call(_context, 'mousedown', this.labelMouseDown.bind(this));
                this.debouncedLayoutChange();
            }
        }, {
            key: 'scroll',
            value: function scroll() {
                this.debouncedLayoutChange();
            }
        }, {
            key: 'resize',
            value: function resize() {
                this.debouncedLayoutChange();
            }
        }, {
            key: 'layoutChange',
            value: function layoutChange() {
                if (!this.open) {
                    return;
                }

                var topSpace = this.topSpace();
                var bottomSpace = this.bottomSpace();

                var lastDirection = this.direction;

                if ( // Set to top?
                topSpace > bottomSpace // Top space greater than bottom
                && bottomSpace < 300) {
                    this.direction = 'top';
                } else {
                    this.direction = 'bottom';
                }

                if (lastDirection !== this.direction) {
                    this.updateDirection();
                }

                if (this.direction === 'top') {
                    this.heightSpace = topSpace;
                } else {
                    this.heightSpace = bottomSpace;
                }

                this.components.panel.components.list.render();
            }
        }, {
            key: 'keyDown',
            value: function keyDown(event) {
                if (this.open && event.keyCode == _keys.ARROW_UP) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.components.panel.components.list.up();
                } else if (this.open && event.keyCode == _keys.ARROW_DOWN) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.components.panel.components.list.down();
                } else if (this.open && event.keyCode == _keys.ENTER) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.components.panel.components.list.selectCurrent();
                } else if (this.open && event.keyCode == _keys.TAB && !event.shiftKey) {
                    this.components.panel.components.list.selectCurrent();
                } else if (event.keyCode == _keys.TAB && event.shiftKey && document.activeElement == this.components.panel.components.searchInput.elements.input) {
                    this.ignoreFocus = true;
                }
            }
        }, {
            key: 'keyUp',
            value: function keyUp(event) {
                if (event.keyCode === _keys.ESC) {
                    this.closePanel();
                    this.ignoreFocus = true;
                    this.elements.wrapper.focus();
                } else if (event.target === this.elements.wrapper && event.keyCode == _keys.SPACE) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.togglePanel();
                } else if (event.keyCode == _keys.ARROW_UP || event.keyCode == _keys.ARROW_DOWN || event.keyCode == _keys.ENTER) {
                    event.preventDefault();
                    event.stopPropagation();
                } else if (ignoredKeysOnSearch.indexOf(event.keyCode) == -1) {
                    if (!this.typing) {
                        this.typing = true;
                        if (this.clearOnType) {
                            this.select({
                                content: null,
                                value: null
                            });
                        }
                        this.components.panel.clear();
                    }
                    this.debouncedFind();
                }
            }
        }, {
            key: 'iconOrTextClick',
            value: function iconOrTextClick(event) {
                if (document.activeElement === this.elements.wrapper) {
                    //this.togglePanel();
                }
            }
        }, {
            key: 'wrapperFocus',
            value: function wrapperFocus(event) {
                if (!event.isTrigger && !this.ignoreFocus) {
                    this.openPanel();
                }
                this.ignoreFocus = false;
            }
        }, {
            key: 'blur',
            value: function blur() {
                if (!this.ignoreBlur) {
                    if (!_StormBox2.default.isArray(this.elements.hiddenInput)) {
                        var _context3;

                        if (this.value !== this.valueOnOpen) {
                            var _context2;

                            this.valueOnOpen = this.value;
                            (_context2 = this.elements.hiddenInput, _events.trigger).call(_context2, 'change');
                            (_context2 = this.elements.textInput, _events.trigger).call(_context2, 'change');
                        }
                        (_context3 = this.elements.hiddenInput, _events.trigger).call(_context3, 'blur');
                        (_context3 = this.elements.textInput, _events.trigger).call(_context3, 'blur');
                    }
                    this.closePanel();
                }
                this.ignoreBlur = false;
            }
        }, {
            key: 'wrapperMouseDown',
            value: function wrapperMouseDown(event) {
                if (!this.open && document.activeElement === this.elements.wrapper) {
                    this.openPanel();
                } else if (this.open && document.activeElement === this.elements.wrapper) {
                    this.ignoreBlur = true;
                    this.components.panel.components.searchInput.elements.input.focus();
                    this.ignoreFocus = true;
                } else if (_StormBox2.default.isFrom(event.target, this.components.panel.components.pagination.elements.goLeft) || _StormBox2.default.isFrom(event.target, this.components.panel.components.pagination.elements.goRight) || event.target == this.components.panel.components.searchInput.elements.input) {
                    return;
                } else if (document.activeElement === this.components.panel.components.searchInput.elements.input) {
                    if (this.open && _StormBox2.default.isFrom(event.target, this.components.presentText.element)) {
                        this.ignoreFocus = true;
                    }
                    this.closePanel();
                    this.ignoreBlur = true;
                } else {
                    this.ignoreFocus = false;
                    this.ignoreBlur = false;
                }
            }
        }, {
            key: 'labelMouseDown',
            value: function labelMouseDown(event) {
                if (_StormBox2.default.isFrom(event.target, this.elements.wrapper) || this.multiple && _StormBox2.default.isFrom(event.target, this.components.multiple.element)) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.elements.wrapper.focus();
            }
        }]);

        return _class;
    }(Parent);
};

},{"../components/StormBox":10,"../util/events":27,"../util/keys":28}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'find',
            value: function find() {
                var _this2 = this;

                return new Promise(function () {
                    if (_this2.finding) {
                        _this2.abort();
                    }
                    var query = _this2.components.panel.components.searchInput.value();
                    if (query.length < _this2.minLength && !_this2.forcedSearch) {
                        _this2.forcedSearch = false;
                        return;
                    }
                    _this2.findingStart();
                    var params = _extends({}, _this2.otherParams, _defineProperty({}, _this2.queryParam, query));
                    Object.keys(_this2.references).forEach(function (key) {
                        if (!_this2.references[key]) {
                            if (_this2.softErrors) {
                                return console.warn('Reference ' + key + ' is not valid!');
                            } else {
                                throw new Error('Reference ' + key + ' is not valid!');
                            }
                        }
                        params[key] = _this2.references[key].value;
                    });

                    var results = { data: [] };
                    _this2.source.find(params).then(function (newResults) {
                        if (newResults === 'aborted') {
                            return;
                        }
                        _this2.lastParams = params;
                        results = newResults;
                        _this2.paginationData = newResults.pagination;
                        _this2.components.panel.show(results);
                        if (_this2.autoSelectWhenOneResult && (!_this2.open || !_this2.emptyItem) && results && results.data && results.data.length == 1) {
                            _this2.select({
                                content: results.data[0].content,
                                value: results.data[0].value
                            });
                        } else if (!_this2.open && (!_this2.autoFind || results && results.data && results.data.length > 1)) {
                            _this2.cancelOthers();
                            _this2.openPanel();
                            _this2.ignoreBlur = false;
                        }
                        _this2.findingEnd();
                    }).catch(function (error) {
                        if (error instanceof Error) {
                            _this2.components.panel.error(error);
                        } else {
                            _this2.components.panel.warning(error);
                        }

                        if (_this2.autoSelectWhenOneResult && (!_this2.open || !_this2.emptyItem) && results && results.data && results.data.length == 1) {
                            _this2.select({
                                content: results.data[0].content,
                                value: results.data[0].value
                            });
                        } else if (!_this2.open && (!_this2.autoFind || results && results.data && results.data.length > 1)) {
                            _this2.cancelOthers();
                            _this2.openPanel();
                        }
                        _this2.findingEnd();
                    });
                });
            }
        }, {
            key: 'feed',
            value: function feed(offset) {
                var _this3 = this;

                if (this.finding) {
                    this.source.abort();
                    this.findingEnd();
                }
                this.findingStart();
                return this.source.find(_extends({}, this.lastParams, { offset: offset })).then(function (newResults) {
                    if (newResults === 'aborted') {
                        return [];
                    }
                    _this3.findingEnd();
                    return newResults.data;
                }).catch(function (error) {
                    _this3.components.panel.error(error);
                    _this3.findingEnd();
                });
            }
        }, {
            key: 'cancelOthers',
            value: function cancelOthers() {
                var others = document.querySelectorAll('[data-ac-loading],[data-ac-open]');
                Array.prototype.slice.call(others).map(function (element) {
                    return element.autoComplete;
                }).filter(function (autoComplete) {
                    return typeof autoComplete !== 'undefined';
                }).forEach(function (autoComplete) {
                    autoComplete.abort();
                    autoComplete.closePanel();
                    autoComplete.ignoreBlur = false;
                });
            }
        }, {
            key: 'abort',
            value: function abort() {
                this.source.abort();
                this.findingEnd();
            }
        }, {
            key: 'findingStart',
            value: function findingStart() {
                // Set flag
                this.typing = false;
                this.finding = true;
                // Loading info on element
                this.elements.wrapper.setAttribute('data-ac-loading', 'true');
                // Start spin
                this.components.icon.loadingStart();
            }
        }, {
            key: 'findingEnd',
            value: function findingEnd() {
                // Set flag
                this.finding = false;
                // Loading info on element
                this.elements.wrapper.removeAttribute('data-ac-loading');
                // Stop spin
                this.components.icon.loadingStop();
            }
        }]);

        return _class;
    }(Parent);
};

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'enable',
            value: function enable() {
                if (!this.disabled) {
                    return;
                }
                this.disabled = false;
                // If still readOnly ignore reconstruction
                if (this.readOnly) {
                    return;
                }
                this.elements.wrapper.setAttribute('tabindex', '0');
                this.elements.wrapper.className = this.style.wrapper;
                this.components.icon.element.className = this.style.rightIcon;
                this.multiple && this.components.multiple.render();
                this.relatedApply(function (element) {
                    return element.disabled = false;
                });
            }
        }, {
            key: 'disable',
            value: function disable() {
                if (this.disabled) {
                    return;
                }
                this.disabled = true;
                this.elements.wrapper.removeAttribute('tabindex');
                this.closePanel();
                this.elements.wrapper.className = this.style.disabledWrapper;
                this.components.icon.element.className = this.style.disabledRightIcon;
                this.multiple && this.components.multiple.render();
                this.relatedApply(function (element) {
                    return element.disabled = true;
                });
            }
        }, {
            key: 'canReadAndWrite',
            value: function canReadAndWrite() {
                if (!this.readOnly) {
                    return;
                }
                this.readOnly = false;
                // If still disabled ignore reconstruction
                if (this.disabled) {
                    return;
                }
                this.elements.wrapper.setAttribute('tabindex', '0');
                this.elements.wrapper.className = this.style.wrapper;
                this.components.icon.element.className = this.style.rightIcon;
                this.multiple && this.components.multiple.render();
                this.relatedApply(function (element) {
                    return element.readOnly = false;
                });
            }
        }, {
            key: 'canRead',
            value: function canRead() {
                if (this.readOnly) {
                    return;
                }
                this.readOnly = true;
                this.elements.wrapper.removeAttribute('tabindex');
                this.closePanel();
                this.elements.wrapper.className = this.style.readOnlyWrapper;
                this.components.icon.element.className = this.style.readOnlyRightIcon;
                this.multiple && this.components.multiple.render();
                this.relatedApply(function (element) {
                    return element.readOnly = true;
                });
            }
        }, {
            key: 'required',
            value: function required() {
                if (this.emptyItem === false || this.multiple) {
                    return;
                }
                this.emptyItem = false;
                this.closePanel();
                this.relatedApply(function (element) {
                    return element.required = true;
                });
            }
        }, {
            key: 'optional',
            value: function optional() {
                if (this.emptyItem === true) {
                    return;
                }
                this.emptyItem = true;
                this.closePanel();
                this.relatedApply(function (element) {
                    return element.required = false;
                });
            }
        }]);

        return _class;
    }(Parent);
};

},{}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'openPanel',
            value: function openPanel() {
                if (this.disabled || this.readOnly) {
                    return;
                }

                this.open = true;
                this.elements.wrapper.setAttribute('data-ac-open', 'true');
                this.valueOnOpen = this.value;
                this.elements.wrapper.className = this.style.openWrapper;
                this.components.panel.element.style.display = 'inline-block';
                this.ignoreBlur = true;
                this.components.panel.components.searchInput.elements.input.focus();
                this.components.panel.components.searchInput.elements.input.setSelectionRange(0, this.components.panel.components.searchInput.elements.input.value.length);

                if (this.autoFind) {
                    this.debouncedFind();
                }

                // Return scroll to original position
                this.components.presentText.scrollToHide();

                // Update layout composition
                this.layoutChange();
                this.updateDirection();
            }
        }, {
            key: 'closePanel',
            value: function closePanel() {
                if (!this.open) {
                    return;
                }
                this.open = false;
                this.elements.wrapper.className = this.style.wrapper;
                this.components.panel.element.style.display = 'none';

                // Update layout composition
                this.layoutChange();
                this.updateDirection();

                // Open info
                this.elements.wrapper.removeAttribute('data-ac-open');
            }
        }, {
            key: 'togglePanel',
            value: function togglePanel() {
                if (!this.open) {
                    this.openPanel();
                } else {
                    this.closePanel();
                }
            }
        }]);

        return _class;
    }(Parent);
};

},{}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'topSpace',
            value: function topSpace() {
                return this.elements.wrapper.getBoundingClientRect().top;
            }
        }, {
            key: 'bottomSpace',
            value: function bottomSpace() {
                return window.innerHeight - (this.topSpace() + this.elements.wrapper.getBoundingClientRect().height);
            }
        }, {
            key: 'updateDirection',
            value: function updateDirection() {
                if (this.direction === 'top') {
                    this.elements.wrapper.classList.remove(this.style.bottom);
                    this.elements.wrapper.classList.add(this.style.top);
                } else {
                    this.elements.wrapper.classList.remove(this.style.top);
                    this.elements.wrapper.classList.add(this.style.bottom);
                }
            }
        }]);

        return _class;
    }(Parent);
};

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StormBox = require('../components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'relatedReplica',
            value: function relatedReplica() {
                var _this2 = this;

                this.relatedApply(function (element) {
                    return _this2.replica(element);
                });
            }
        }, {
            key: 'replica',
            value: function replica(element) {
                if (element.disabled || element.hasAttribute('disabled')) {
                    this.disable();
                }
                if (element.readOnly || element.hasAttribute('readonly')) {
                    this.canRead();
                }
                if (element.required || element.hasAttribute('required')) {
                    this.required();
                }
            }
        }]);

        return _class;
    }(Parent);
};

},{"../components/StormBox":10}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StormBox = require('../components/StormBox');

var _StormBox2 = _interopRequireDefault(_StormBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Parent) {
    return function (_Parent) {
        _inherits(_class, _Parent);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'select',
            value: function select(_ref) {
                var content = _ref.content,
                    value = _ref.value,
                    additional = _ref.additional,
                    others = _ref.others;

                if (!this.multiple) {
                    // Set instance data
                    this.value = value;
                    this.content = content;

                    // Inject data in original inputs
                    this.elements.hiddenInput.value = value || '';
                    this.elements.textInput.value = content || '';
                    // Present text
                    this.components.presentText.value(value || '');
                    this.components.presentText.text(content || ' ');

                    // Async set other fields data and clear previous
                    this.setOrClearOtherFields(others);
                } else {
                    var currentIndex = void 0;
                    if (this.distinct && (currentIndex = this.value.indexOf(String(value))) !== -1) {
                        this.value.splice(currentIndex, 1);
                        this.content.splice(currentIndex, 1);
                    } else {
                        // Set instance data
                        this.value.push(String(value));
                        this.content.push(String(content));
                    }

                    this.components.multiple.render();
                    this.components.panel.components.list.render();

                    // Present text
                    this.components.presentText.value('');
                    if (this.value.length === 1) {
                        this.components.presentText.text(this.value.length + ' ' + this.messages.singularMultipleItems);
                    } else if (this.value.length > 1) {
                        this.components.presentText.text(this.value.length + ' ' + this.messages.pluralMultipleItems);
                    } else {
                        this.components.presentText.text(' ');
                    }
                }
            }
        }, {
            key: 'remove',
            value: function remove(index) {
                this.value.splice(index, 1);
                this.content.splice(index, 1);
                this.components.multiple.render();
                this.components.panel.components.list.render();
                this.components.presentText.value('');
                if (this.value.length === 1) {
                    this.components.presentText.text(this.value.length + ' ' + this.messages.singularMultipleItems);
                } else if (this.value.length > 1) {
                    this.components.presentText.text(this.value.length + ' ' + this.messages.pluralMultipleItems);
                } else {
                    this.components.presentText.text(' ');
                }
            }
        }, {
            key: 'setOrClearOtherFields',
            value: function setOrClearOtherFields() {
                var others = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                var length = others.length;

                // Clone usedOtherFields from previous settings to clear if not replaced
                var fieldsToRevert = this.usedOtherFields.slice(0);
                // Iterate other fields data to set
                for (var index = 0; index < length; index++) {
                    var indexInUsed = this.usedOtherFields.indexOf(others[index].field);
                    // Find element and project element to set new data or revert to oldest
                    var element = document.querySelector('[name="' + others[index].field + '"]');

                    if (!element) {
                        if (this.softErrors) {
                            return console.warn('Element of other field \'' + others[index].field + '\' not found!');
                        } else {
                            throw new Error('Element of other field \'' + others[index].field + '\' not found!');
                        }
                    }

                    _StormBox2.default.projectElementSettings(element, others[index], this.softErrors);
                    if (indexInUsed === -1) {
                        // Set as used field
                        this.usedOtherFields[this.usedOtherFields.length] = others[index].field;
                    } else {
                        // If is setted remove from temporary revert intention list
                        fieldsToRevert.splice(fieldsToRevert.indexOf(others[index].field), 1);
                    }
                }

                // Iterate fields to revert to the original data
                var revertLength = fieldsToRevert.length;
                for (var _index = 0; _index < revertLength; _index++) {
                    // Find element and project element to revert to oldest
                    var _element = document.querySelector('[name="' + fieldsToRevert[_index] + '"]');
                    _StormBox2.default.projectElementSettings(_element, {}, this.softErrors);
                }
            }
        }]);

        return _class;
    }(Parent);
};

},{"../components/StormBox":10}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Source = require('./Source');

var _Source2 = _interopRequireDefault(_Source);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function nestedSerialize(params) {
    var history = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return Object.keys(params).map(function (key) {
        if (_typeof(params[key]) === 'object' && params[key] !== null) {
            return nestedSerialize(params[key], [].concat(_toConsumableArray(history), [key]));
        }
        var keys = [].concat(_toConsumableArray(history), [key]);
        var mainKey = keys.shift();
        return encodeURIComponent(mainKey + (keys.length ? '[' + keys.join('][') + ']' : '')) + '=' + encodeURIComponent(params[key]);
    }).join('&');
}

var AjaxSource = function () {
    function AjaxSource(url) {
        var headerXMLHttpRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var beforeSend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, AjaxSource);

        this.url = url;
        this.request = null;
        this.headerXMLHttpRequest = headerXMLHttpRequest;
        this.beforeSend = beforeSend;
    }

    _createClass(AjaxSource, [{
        key: 'prepareRequest',
        value: function prepareRequest(params) {
            this.request = new XMLHttpRequest();
            var paramUrl = nestedSerialize(params);
            this.request.open('GET', this.url + '?' + paramUrl, true);
            if (this.headerXMLHttpRequest) {
                this.request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            }
            this.beforeSend && this.beforeSend(this.request);
        }
    }, {
        key: 'abort',
        value: function abort() {
            this.request && this.request.abort && this.request.abort();
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                _this.request.onreadystatechange = function () {
                    if (_this.request.readyState != 4) {
                        return;
                    }
                    if (_this.request.status == 0) {
                        return resolve('aborted');
                    }
                    if (_this.request.status == 200) {
                        var json = void 0;
                        try {
                            json = JSON.parse(_this.request.responseText);
                        } catch (err) {
                            return reject(new Error('Parsing Error: invalid response. ' + _this.request.responseText.replace(/\n/, '')));
                        }
                        _this.request = null;
                        resolve(json);
                    } else {
                        var error = 'Error Code: ' + _this.request.status;
                        try {
                            var parsedError = JSON.parse(_this.request.responseText);
                            error += _this.request.statusText && _this.request.statusText.trim().length ? '; Status: ' + _this.request.statusText : '';
                            if (parsedError.message) {
                                if (_this.request.status >= 400 && _this.request.status < 500) {
                                    return reject(parsedError);
                                }
                                error += parsedError.message && parsedError.message.trim().length ? '; Status: ' + parsedError.message.trim() : '';
                            } else {
                                error += _this.request.responseText && _this.request.responseText.trim().length ? '; Status: ' + _this.request.responseText.trim() : '';
                            }
                        } catch (err) {
                            error += _this.request.statusText && _this.request.statusText.trim().length ? '; Status: ' + _this.request.statusText : '';
                            error += _this.request.responseText && _this.request.responseText.trim().length ? '; Status: ' + _this.request.responseText.trim() : '';
                        }
                        reject(new Error(error));
                    }
                };
                _this.request.send();
            });
        }
    }, {
        key: 'find',
        value: function find(params) {
            this.prepareRequest(params);
            return this.send();
        }
    }]);

    return AjaxSource;
}();

exports.default = AjaxSource;

},{"./Source":24}],22:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Source = require('./Source');

var _Source2 = _interopRequireDefault(_Source);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArraySource = function () {
    function ArraySource() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, ArraySource);

        this.data = data;
    }

    _createClass(ArraySource, [{
        key: 'find',
        value: function find(_ref) {
            var _this = this;

            var value = _ref.value;

            return new Promise(function (resolve) {
                resolve({
                    data: _this.data
                });
            });
        }
    }]);

    return ArraySource;
}();

exports.default = ArraySource;

},{"./Source":24}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Source = require('./Source');

var _Source2 = _interopRequireDefault(_Source);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectSource = function () {
    function SelectSource() {
        _classCallCheck(this, SelectSource);
    }

    _createClass(SelectSource, [{
        key: 'find',
        value: function find(_ref) {
            var value = _ref.value;

            return new Promise(function (resolve) {
                return resolve();
            });
        }
    }]);

    return SelectSource;
}();

exports.default = SelectSource;

},{"./Source":24}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Source = function () {
    function Source() {
        _classCallCheck(this, Source);
    }

    _createClass(Source, [{
        key: 'find',
        value: function find(_ref) {
            var value = _ref.value;

            return new Promise(function (resolve, reject) {
                return reject(new Error('Source class is abstract!'));
            });
        }
    }, {
        key: 'abort',
        value: function abort() {}
    }]);

    return Source;
}();

exports.default = Source;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

},{}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.elem = elem;
exports.input = input;
exports.div = div;
exports.ul = ul;
exports.li = li;
exports.a = a;
exports.i = i;
exports.strong = strong;
exports.span = span;
exports.button = button;

var _extend = require('extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elem(tag, props) {
    var domElem = document.createElement(tag);
    (0, _extend2.default)(domElem, props);

    for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        children[_key - 2] = arguments[_key];
    }

    children.forEach(function (child) {
        domElem.appendChild(child);
    });
    return domElem;
};

function input(props) {
    return elem('input', props);
};

function div(props) {
    for (var _len2 = arguments.length, children = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        children[_key2 - 1] = arguments[_key2];
    }

    return elem.apply(undefined, ['div', props].concat(children));
};

function ul(props) {
    for (var _len3 = arguments.length, children = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        children[_key3 - 1] = arguments[_key3];
    }

    return elem.apply(undefined, ['ul', props].concat(children));
};

function li(props) {
    for (var _len4 = arguments.length, children = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        children[_key4 - 1] = arguments[_key4];
    }

    return elem.apply(undefined, ['li', props].concat(children));
};

function a(props) {
    for (var _len5 = arguments.length, children = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        children[_key5 - 1] = arguments[_key5];
    }

    return elem.apply(undefined, ['a', props].concat(children));
};

function i(props) {
    for (var _len6 = arguments.length, children = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        children[_key6 - 1] = arguments[_key6];
    }

    return elem.apply(undefined, ['i', props].concat(children));
};

function strong(props) {
    for (var _len7 = arguments.length, children = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        children[_key7 - 1] = arguments[_key7];
    }

    return elem.apply(undefined, ['strong', props].concat(children));
};

function span(props) {
    for (var _len8 = arguments.length, children = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        children[_key8 - 1] = arguments[_key8];
    }

    return elem.apply(undefined, ['span', props].concat(children));
};

function button(props) {
    for (var _len9 = arguments.length, children = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        children[_key9 - 1] = arguments[_key9];
    }

    return elem.apply(undefined, ['button', props].concat(children));
};

},{"extend":1}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trigger = trigger;
exports.on = on;
function trigger(eventName) {
    if (window.CustomEvent) {
        var ev = new CustomEvent(eventName);
        ev.isTrigger = true;
        this.dispatchEvent(ev);
    } else if (document.createEvent) {
        var ev = document.createEvent('HTMLEvents');
        ev.initEvent(eventName, true, false);
        ev.isTrigger = true;
        this.dispatchEvent(ev);
    } else {
        this.fireEvent('on' + eventName);
    }
};

function on(eventName, callback) {
    this.addEventListener(eventName, callback);
    return this;
}

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var ARROW_UP = exports.ARROW_UP = 38;
var ARROW_DOWN = exports.ARROW_DOWN = 40;
var ARROW_RIGHT = exports.ARROW_RIGHT = 39;
var ARROW_LEFT = exports.ARROW_LEFT = 37;
var TAB = exports.TAB = 9;
var SHIFT = exports.SHIFT = 16;

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var MainExtendedParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        function _class() {
            _classCallCheck(this, _class);
        }

        return _class;
    }();

    for (var _len = arguments.length, mixins = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        mixins[_key - 1] = arguments[_key];
    }

    return mixins.reduce(function (NewParent, Mixin) {
        return Mixin(NewParent);
    }, MainExtendedParent);
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

},{}]},{},[13])(13)
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
/******/ ]);